import React from "react"

const Header = () => {
  return (
    <header>
      <h1 className="mainheading">Virtual Lolly!</h1>
      <p className="subheading">Yes everyone gets a lollipop. SeemsGood.</p>
    </header>
  )
}

export default Header
